import { render, staticRenderFns } from "./FormBucket.vue?vue&type=template&id=de8e79de&"
import script from "./FormBucket.vue?vue&type=script&lang=js&"
export * from "./FormBucket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports